import React from 'react';
import { SearchField, Dropdown, Icon } from '@openedx/paragon';
import { RiArrowUpDownLine } from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';

export const SORT_OPTIONS = [
  { value: 'newest', messageKey: 'sortNewest' },
  { value: 'nameAsc', messageKey: 'sortNameAsc' },
  { value: 'nameDesc', messageKey: 'sortNameDesc' },
  { value: 'priceAsc', messageKey: 'sortPriceAsc' },
  { value: 'priceDesc', messageKey: 'sortPriceDesc' },
  { value: 'rating', messageKey: 'sortRating' },
];

const ExploreCoursesHeader = ({
  searchValue,
  onSearchChange,
  sortValue,
  onSortChange,
  paymentsEnabled,
}) => {
  const { formatMessage } = useIntl();
  const visibleSortOptions = paymentsEnabled
    ? SORT_OPTIONS
    : SORT_OPTIONS.filter((o) => o.value !== 'priceAsc' && o.value !== 'priceDesc');
  const activeOption = visibleSortOptions.find((o) => o.value === sortValue) || visibleSortOptions[0];

  return (
    <section className="explore-courses-header">
      <h2 className="explore-courses-header__title">
        {formatMessage(messages.exploreHeading)}
      </h2>

      <div className="explore-courses-header__search-row">
        <SearchField
          size="lg"
          className="explore-courses-header__search"
          placeholder={formatMessage(messages.searchPlaceholder)}
          value={searchValue}
          onChange={onSearchChange}
          onSubmit={onSearchChange}
          onClear={() => onSearchChange('')}
        />
        <Dropdown>
          <Dropdown.Toggle
            id="explore-courses-sort-toggle"
            variant="outline-secondary"
            size="lg"
            className="explore-courses-header__sort-toggle"
          >
            <Icon src={RiArrowUpDownLine} className="explore-courses-header__sort-icon" />
            <span>{formatMessage(messages[activeOption.messageKey])}</span>
          </Dropdown.Toggle>
          <Dropdown.Menu align="right">
            {visibleSortOptions.map((option) => (
              <Dropdown.Item
                key={option.value}
                active={option.value === sortValue}
                onClick={() => onSortChange(option.value)}
              >
                {formatMessage(messages[option.messageKey])}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </section>
  );
};

export default ExploreCoursesHeader;
